import Vue from 'vue';

Vue.filter('kebab', value => value.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase());
